import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Back from "../components/Back";
import FormRegistration from "../components/Form";
import Menu from "../components/Menu";
import Unauthorized from "../components/Unauthorized";
import { baseService } from "../helpers/baseService";
import { setTitle } from "../helpers/title";
import { useAuth } from "../helpers/useAuth";
import { config } from "../helpers/config";

export default function Event() {
  const { id } = useParams();
  const { auth } = useAuth();
  const [event, setEvent] = useState();
  const [loadingPage, setLoadingPage] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoadingPage(true);
    baseService.get(
      config.services.event.getEventById + id,
      (res) => {
        setEvent(res.data);
        setTitle(`${res.data.eventName} | Event`);
        setLoadingPage(false);
      },
      (err) => {
        if (err.status === 404) navigate("/");
        console.log(err);
      }
    );
    // eslint-disable-next-line
  }, [id]);

  return (
    <div>
      <div className="container" />
      {auth && <Back title="Registrasi" />}
      <div className="content">
        {auth ? (
          <FormRegistration event={event} loadingPage={loadingPage} />
        ) : (
          <Unauthorized />
        )}
      </div>
      <Menu />
    </div>
  );
}
